export function validMaxDate(field) {
    let day, month, year;
    let max_day, max_month, max_year;
    const date = field.value.split("-");
    const max = field.getAttribute("data-date-max").split("-");
    const format = field.getAttribute("data-date-format") || "YYYY-MM-DD";

    if (format == "YYYY-MM-DD") {
        year = date[0];
        month = date[1];
        day = date[2];

        max_year = max[0];
        max_month = max[1];
        max_day = max[2];
    }

    return Date.UTC(year, month, day) <= Date.UTC(max_year, max_month, max_day);
}
